/**
 * Tree-test localStorage key helper (TASK-260).
 *
 * Single source of truth for the per-user manual tree-test slot key, so the
 * key string `tree-test:<userId>` is never duplicated. Used by both the
 * `useTreeTestStorage` hook and the reindex invalidation on the data-sources
 * page.
 */

/** localStorage key for a user's single manual tree-test slot. */
export function treeTestStorageKey(userId: string): string {
  return `tree-test:${userId}`;
}

/**
 * Remove the manual tree-test slot for a user (used on reindex invalidation
 * and by the «Сбросить» button). No-op when localStorage is unavailable.
 */
export function clearTreeTestSlot(userId: string): void {
  if (!userId) return;
  try {
    localStorage.removeItem(treeTestStorageKey(userId));
  } catch {
    // localStorage may be unavailable (SSR / privacy mode) — fail silently.
  }
}
